/**
 * i18n setup — Phase 8.
 *
 * Strategy: ship 4 locales (es complete, en complete enough, pt + hi
 * functional with es fallback). i18next-browser-languagedetector picks the
 * initial language from (1) localStorage `i18nextLng`, (2) `navigator.language`,
 * (3) `es` default. The AuthContext layer overrides this with
 * `user.preferred_language` once the session is hydrated, and the language
 * switcher writes back via `POST /api/me/language` + `i18n.changeLanguage`.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import es from "./locales/es.json";
import en from "./locales/en.json";
import pt from "./locales/pt.json";
import hi from "./locales/hi.json";

export const SUPPORTED_LANGUAGES = [
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt },
      hi: { translation: hi },
    },
    fallbackLng: "es",
    supportedLngs: ["es", "en", "pt", "hi"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    returnNull: false,
  });

export default i18n;
